import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () =>
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-md-offset-4">
                <h2 className="center">Page not found (404)</h2>
                <p className="center">We can&apos;t find the page you&apos;re looking for.</p>
                <p className="center">Here&apos;s a few links that might be helpful:</p>
                <p className="center"><Link to="/">Home</Link></p>
                <p className="center"><Link to="/signUp">Sign Up</Link></p>
                <p className="center"><Link to="/signIn">Sign In</Link></p>
            </div>
        </div>
    </div>

export default NotFound


// WEBPACK FOOTER //
// ./src/pages/not_found.jsx